import React, { useContext, memo } from 'react'
import { CurrentUserContext } from '../../../context/Shared/CurrentUser.context'
import Avatar from '@mui/material/Avatar'
import { theme } from '../../../styles/theme.style'
import { getFirstName, getInitials } from '../../../utils/functions'
import { useTranslation } from 'react-i18next'
import { SideBarContext } from '../../../context/Shared/SideBar.context'
import { SelectPortal } from '../SelectPortal/SelectPortal.component'
import { AiFillCloseCircle } from 'react-icons/ai'
import PropTypes from 'prop-types'

import styles from './SideBar.module.scss'

const TopSideBar = ({ onlineStatus }) => {
  const { me } = useContext(CurrentUserContext)
  const { isTabletOrMobile, setSideBarVisibility } = useContext(SideBarContext)
  const { t } = useTranslation()

  const connectionStatus = (
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 6 }}>
      <span className={onlineStatus ? styles.onlineDot : styles.offlineDot} />
      <span style={{ fontSize: 11, color: onlineStatus ? '#4caf50' : '#f44336', opacity: 0.9 }}>
        {onlineStatus ? t('Connected') : t('Disconnected')}
      </span>
    </div>
  )

  return (
    <>
      {isTabletOrMobile ? (
        <div className={styles.mobileHeader}>
          <div className={styles.mobileHeader__top}>
            <span className={styles.mobileHeader__welcome}>
              {t('Welcome')}, <strong>{getFirstName(me?.name || '')}</strong>
            </span>
            <button
              className={styles.closeButton}
              onClick={() => setSideBarVisibility(false)}
            >
              <AiFillCloseCircle className={styles.closeButton__icon} />
            </button>
          </div>
          <div className={styles.mobileHeader__portal}>
            <SelectPortal />
          </div>
          {connectionStatus}
        </div>
      ) : (
        <div className={styles.welcomeSection}>
          <Avatar
            sx={{
              width: 72,
              height: 72,
              bgcolor: theme.COLOR_LIGHT_BLUE,
              mb: 1,
              fontSize: 28
            }}
          >
            {getInitials(me?.name)}
          </Avatar>
          <div className={styles.welcomeTextRow}>
            <span className={styles.welcomeTextLabel}>{t('Welcome')}</span>
            <span className={styles.welcomeTextName}>{getFirstName(me?.name || '')}</span>
          </div>
          {connectionStatus}
        </div>
      )}
    </>
  )
}

TopSideBar.propTypes = {
  onlineStatus: PropTypes.bool
}

export default memo(TopSideBar)
